export enum TemporaryTireStatusesEnum {
	PENDING_ADD = 'PENDING_ADD',
	PENDING_TRANSFER = 'PENDING_TRANSFER',
	PENDING_UPDATEWITHDOTNO = 'PENDING_UPDATEWITHDOTNO',
	PENDING_UPDATEWITHTRR = 'PENDING_UPDATEWITHTRR',
	PENDING_RECORDSHORTAGEINSHIPMENT = 'PENDING_RECORDSHORTAGEINSHIPMENT',
	PENDING_VIEWSHORTINSHIPMENT = 'PENDING_VIEWSHORTINSHIPMENT',
}